<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @search-reset="searchClear"
        @row-save="handleSave" @row-update="handleUpdate" @selection-change="handleSelectionChange"
        @size-change="pageSizeChange" @current-change="pageChange">
        <!--  <template slot="search">
          <el-form-item label="安装人员" size="small" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="currservicePeople" placeholder="请选择服务人员" filterable remote
                :remote-method="remoteMethod">
                <el-option v-for="item2 in currservicePeoples" :key="item2.id" :label="item2.realName"
                  :value="item2.id"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="调试人员" size="small" style="margin-top: 4px">
            <el-select v-model="searchDebugStaffSelect" clearable filterable="filterable" placeholder="请选择调试人员">
              <el-option v-for="item2 in staffdebugSelects" :key="item2.id" :label="item2.name"
                :value="item2.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工程进度" size="small" style="margin-top: 4px">
            <el-select v-model="searchPlanSelect" clearable placeholder="请选择工程进度">
              <el-option v-for="item2 in planIdSelects" :key="item2.id" :label="item2.name" :value="item2.id"></el-option>
            </el-select>
          </el-form-item>
        </template> -->
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="mini" plain @click.stop="handleAdd()">新增</el-button>

          <el-button type="success" icon="el-icon-download" size="mini" plain
            @click="downloadExceltest(scope.row)">下载Excel</el-button>
          <el-button type="warning" icon="el-icon-delete" size="mini" plain
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">删除</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" plain
            @click.stop="handleDelForce('DELETE_OPTION', '物理删除')">物理删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text" style="color: #67C23A" size="mini" icon="el-icon-view" plain
            @click.stop="handleDetail(scope.row, scope.index)">查看</el-button>
          <el-button style="color: #909399" type="text" size="mini" icon="el-icon-edit" plain
            @click.stop="handleEdit(scope.row, scope.index)">编辑</el-button>
          <el-button style="color: #F56C6C" type="text" size="mini" icon="el-icon-delete" plain
            @click.stop="handleSingleDel(scope.row, scope.index)">删除</el-button>
        </template>
        <template slot-scope="scope" slot="menuForm">
          <el-button type="primary" size="medium" plain v-if="scope.type == 'view'"
            @click="downloadExcelView(scope.row)">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="gatherPlansForm">
          <div>
            <el-table :data="gatherPlans" border>
              <el-table-column prop="content" align="center" label="清洗年检记录">
                <template slot-scope="scope">
                  <el-input type="input" name="content" v-model="scope.row.content"
                    :value="scope.row.content"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="checkTime" align="center" label="清洗年检时间">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.checkTime" type="datetime" placeholder="选择清洗年检时间"
                    value-format="timestamp" default-time="12:00:00"></el-date-picker>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button type="warning" icon="el-icon-check" size="small"
                    @click="handleGatherPlansDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleGatherPlansAddRows()">增加一行</el-button>
            </div>
          </div>
        </template>
        <template slot-scope="scope" slot="firstClassifyIdForm">
          <el-select v-model="currClassify" clearable placeholder="请选择系统大类" @change="chosefirstClassifyId">
            <el-option v-for="item in classifySelects" :key="item.id" :label="item.rootName"
              :value="item.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="secondClassifyIdForm">
          <el-select v-model="currSecondClassify" clearable placeholder="请选择系统小类">
            <el-option v-for="item1 in secondClassifySelects" :key="item1.id" :label="item1.name"
              :value="item1.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="shopNameForm">
          <el-select v-model="currShopNameSelect" filterable="filterable" clearable placeholder="请选择渠道"
            @change="choseshopNameSelect" required value-key="id">
            <el-option v-for="item2 in shopNameSelects" :key="item2.id" :label="item2.name" :value="item2"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="shopMobileForm">
          <el-input v-model="currShopMobileSelect" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="installStaffNameForm">
          <el-select v-model="currInstallStaffSelect" filterable="filterable" multiple clearable placeholder="请选择安装人员">
            <el-option v-for="item2 in staffinstallSelects" :key="item2.id" :label="item2.name"
              :value="item2.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="debugStaffNameForm">
          <el-select v-model="currDebugStaffSelect" clearable multiple filterable="filterable" placeholder="请选择调试人员">
            <el-option v-for="item2 in staffdebugSelects" :key="item2.id" :label="item2.name"
              :value="item2.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="planIdForm">
          <el-select v-model="currPlanSelect" clearable placeholder="请选择工程进度">
            <el-option v-for="item2 in planIdSelects" :key="item2.id" :label="item2.name" :value="item2.id"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="provinceNameForm">
          <el-input type="input" name="title" :value="point.pname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="cityNameForm">
          <el-input type="input" name="title" :value="point.cityname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="areaNameForm">
          <el-input type="input" name="title" :value="point.adname" disabled></el-input>
        </template>
        <template slot-scope="scope" slot="addressForm">
          <el-input type="input" name="title" v-model="point.address"></el-input>
        </template>
        <template slot-scope="scope" slot="provincesPoIntForm">
          <avue-map v-model="point"></avue-map>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
// import { excelaxios } from "@/util/excelaxios";
import { customerInfoTableOption } from "@/const/salesCloud/customerInfoOption";
import {
  findCustomerInfo,
  // findCustomerInfoDownloadExcel,
  // findUsersAll,
  addCustomerInfo,
  editCustomerInfo,
  delCustomerInfo,
  delForceCustomerInfo,
  findClassifySelect,
  findStaffSelect,
  findProjectSelect,
  findShopInfoSelect,
  downloadExcelV2
} from "@/api/salesCloud/customerInfo";
import {
  findItemsByCategory,
  findCategoryAll
} from "@/api/salesCloud/workOrder";
import { DIC } from "@/const/dic";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus, resolveUrlPath } from "@/util/util";
import { findUserList } from "@/api/salesCloud/bindEngineer";

export default {
  name: "customerClassify",
  data() {
    return {
      tableOption: customerInfoTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      currservicePeople: "",
      currservicePeoples: [],
      joinsWorkServiceItems: [],
      serviceCategory: {},
      serviceCategorys: [],
      serviceItem: "",
      tableLoading: false,
      classifySelects: [],
      secondClassifySelects: [],
      staffinstallSelects: [],
      staffdebugSelects: [],
      planIdSelects: [],
      shopNameSelects: [],
      gatherPlans: [],
      currClassify: "",
      currSecondClassify: "",
      currInstallStaffSelect: [],
      searchInstallStaffSelect: "",
      currDebugStaffSelect: [],
      searchDebugStaffSelect: "",
      currPlanSelect: "",
      searchPlanSelect: "",
      currShopNameSelect: {
        name: "",
        mobile: ""
      },
      currShopMobileSelect: "",
      tabelObj: {},
      point: { address: "" },
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
    findClassifySelect().then(res => {
      let data = JSON.parse(res.data);
      this.classifySelects = data;
    });
    findStaffSelect().then(res => {
      let data = JSON.parse(res.data);
      this.staffinstallSelects = data;
      this.staffdebugSelects = data;
    });
    findProjectSelect().then(res => {
      let data = JSON.parse(res.data);
      this.planIdSelects = data;
    });
    findShopInfoSelect().then(res => {
      let data = JSON.parse(res.data);
      this.shopNameSelects = data;
    });
    findCategoryAll().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      this.serviceCategorys = data.rows;
    });
    // let params = {};
    // params.userType = "JOINS_ENGINEER";
    // findUsersAll(params).then(res => {
    //   console.log(res);
    //   let data = JSON.parse(res.data);
    //   this.currservicePeoples = data.rows;
    // });
  },
  watch: {},
  mounted() { },
  computed: {},
  props: [],
  methods: {
    remoteMethod(query) {
      console.log(query);
      if (query.length == 5) {
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.currservicePeoples = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.currservicePeoples = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },
    choseServiceItem(data) {
      console.log(data);
      this.serviceItemId = data;
      console.log(this.serviceItemId);
    },
    choseWorkServiceItem() {
      console.log(this.serviceCategory.id);
      findItemsByCategory(this.serviceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        console.log(res);
        console.log(data);
      });
      this.serviceItem = "";
    },
    downloadExceltest() {
      let params = this.$refs.crud.searchForm;
      downloadExcelV2(params).then(res => {
        console.log(res.data);
        window.open(res);
      });
    },
    downloadExcelInfo() {
      // let params = this.downloadData;
      // let url = `/joins-sales-cloud/v1/new_customer/excel?`;
      // excelaxios(url, params);
      let params = {
        page: this.page.currentPage,
        size: this.page.total
      };
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        const list = data.rows;
        for (let i of list) {
          i.purchaseStatus = parseStatus(
            DIC.STOCK_REMOVAL_STATUS,
            i.purchaseStatus
          );
          i.status = parseStatus(DIC.PRODUCT_STATUS, i.status);
          i.updateTime = formatterDateToUTC(i.updateTime * 1);
          // i.payTime = formatterDateToUTC(i.payTime * 1);
          i.installStaffName =
            i.installStaffName == null ? "" : i.installStaffName;
          i.debugStaffName = i.debugStaffName == null ? "" : i.debugStaffName;
        }
        const header = [];
        for (let i of this.tableOption.column) {
          const obj = {};
          if (
            i.prop == "pactTime" ||
            i.prop == "provinceName" ||
            i.prop == "cityName" ||
            i.prop == "areaName" ||
            i.prop == "provincesPoInt" ||
            i.prop == "relation" ||
            i.prop == "firstClassifyName" ||
            i.prop == "firstClassifyId" ||
            i.prop == "secondClassifyId" ||
            i.prop == "brandAndType" ||
            i.prop == "config" ||
            i.prop == "installTime" ||
            i.prop == "debugTime" ||
            i.prop == "gatherPlans" ||
            i.prop == "isBuyPact" ||
            i.prop == "startDate_endDate" ||
            i.prop == "signNumber" ||
            i.prop == "fileNumber" ||
            i.prop == "shopName" ||
            i.prop == "shopMobile" ||
            i.prop == "installStaffName" ||
            i.prop == "debugStaffName" ||
            i.prop == "planName" ||
            i.prop == "planId" ||
            i.prop == "kingdeeNumber" ||
            i.prop == "otherMobile"
          ) {
            ("");
          } else {
            obj.k = i.prop;
            obj.v = i.label;
            header.push(obj);
          }
        }
        const fileName = "客户信息管理.xlsx";
        exportExcel(header, list, fileName);
      });
    },
    choseshopNameSelect() {
      console.log(this.currShopNameSelect);
      this.currShopMobileSelect = this.currShopNameSelect.mobile;
      console.log(this.currShopMobileSelect);
    },
    handleGatherPlansAddRows() {
      var list = {
        checkTime: new Date(),
        content: ""
      };
      this.gatherPlans.unshift(list);
    },
    handleGatherPlansDelete(index) {
      this.gatherPlans.splice(index, 1);
    },
    chosefirstClassifyId() {
      this.currSecondClassify = "";
      this.secondClassifySelects = [];
      console.log(this.currClassify);
      let params = {};
      params.rootId = this.currClassify;
      if (params.rootId) {
        findClassifySelect(params).then(res => {
          let data = JSON.parse(res.data);
          console.log(data);
          this.secondClassifySelects = data;
        });
      }
    },
    clean() {
      this.currClassify = "";
      this.currSecondClassify = "";
      this.point = {};
      this.point.address = "";
      this.currPlanSelect = "";
      this.gatherPlans = [];
      this.currDebugStaffSelect = [];
      this.currInstallStaffSelect = [];
    },
    searchClear() {
      this.serviceCategory = {};
      this.serviceItem = "";
      this.currClassify = "";
      this.searchPlanSelect = "";
      this.searchInstallStaffSelect = "";
      this.currservicePeople = ""; //服务人员
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      params.serviceCategory = this.serviceCategory.id;
      params.serviceItem = this.serviceItem;
      params.servicePeople = this.currservicePeople;
      console.log(params);
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.updateTimeStart = params.startDate_endDate[0];
        params.updateTimeEnd = params.startDate_endDate[1];
      } else {
        delete params.updateTimeStart;
        delete params.updateTimeEnd;
      }
      this.downloadData = params;
      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;

      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      // this.clean();
      // this.$refs.crud.rowAdd();
      let obj = {
        label: "新增客户信息",
        value: "customerInfo/add"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label)
      });
    },
    handleDetail(row) {
      let obj = {
        label: "查看客户信息",
        value: "customerInfo/view",
        query: { id: row.id }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleEdit(row) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      let obj = {
        label: "编辑客户信息",
        value: "customerInfo/edit",
        query: { id: row.id }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;

      findCustomerInfo(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      if (!this.point.address) {
        this.$message({
          showClose: true,
          message: "客户地址及坐标不能为空",
          type: "error"
        });
        done();
      }
      row.firstClassifyId = this.currClassify;
      row.secondClassifyId = this.currSecondClassify;
      row.details = this.gatherPlans;
      row.details = row.details.map(item => {
        if ("" != item.checkTime) {
          item.checkTime = item.checkTime ? item.checkTime.getTime() : 0;
        }
        return item;
      });
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pcode;
      row.city = this.point.adcode.substring(0, 4) + "00";
      row.area = this.point.adcode;
      row.provinceName = this.point.pname;
      row.cityName = this.point.cityname;
      row.areaName = this.point.adname;
      row.address = this.point.address;
      row.secondClassifyId = this.currSecondClassify;
      row.shopId = this.currShopNameSelect.id;
      if (this.currInstallStaffSelect) {
        row.installStaffId = this.currInstallStaffSelect.join(",");
      }
      if (this.currDebugStaffSelect) {
        row.debugStaffId = this.currDebugStaffSelect.join(",");
      }
      row.planId = this.currPlanSelect;
      delete row.debugStaffName;
      delete row.installStaffName;
      console.log(this.point);
      console.log(row);
      if (row.address && row.province) {
        addCustomerInfo(row).then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "新增成功",
              type: "success"
            });
            done();
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
            done();
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "客户地址及坐标不能为空",
          type: "error"
        });
      }
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },

    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDelForce(row) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          delForceCustomerInfo(ids).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => { });
      console.log(row);
    },
    handleDel(row) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error"
        });
        return;
      }
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delCustomerInfo(ids).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => { });
      console.log(row);
    },
    handleSingleDel(row) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delCustomerInfo(row.id).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => { });
      console.log(row);
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row);
      console.log(this.point);
      row.firstClassifyId = this.currClassify;
      row.secondClassifyId = this.currSecondClassify;
      row.details = this.gatherPlans;
      row.details = row.details.map(item => {
        if ("" != item.checkTime) {
          item.checkTime = item.checkTime ? item.checkTime.getTime() : 0;
        }
        return item;
      });
      row.longitude = row.longitude * 1;
      row.latitude = row.latitude * 1;
      row.address = this.point.address;
      console.log(this.point.location);
      if (this.point.location) {
        row.longitude = this.point.location.lng;
        row.area = this.point.adcode;
        row.provinceName = this.point.pname;
        row.cityName = this.point.cityname;
        row.city = this.point.adcode.substring(0, 4) + "00";
        row.areaName = this.point.adname;
        row.latitude = this.point.location.lat;
        row.province = this.point.pcode;
        row.address = this.point.address;
      }
      row.secondClassifyId = this.currSecondClassify;
      row.shopId = this.currShopNameSelect.id;
      if (this.currInstallStaffSelect) {
        row.installStaffId = this.currInstallStaffSelect.join(",");
      }
      if (this.currDebugStaffSelect) {
        row.debugStaffId = this.currDebugStaffSelect.join(",");
      }
      row.planId = this.currPlanSelect;
      delete row.debugStaffName;
      delete row.installStaffName;
      editCustomerInfo(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
